/* ══════════════════════════════════════════════════════════════════════════
   assets/asf-shop-bg-2.js — SHOP v2 背景（全画面シグナルグリーン柄 + 静電ジッター）
   ★ 2026-07-31(3) 世代替え注記 ★ クライアント報告「Mac ブラウザはキャッシュクリア後も柄が旧スケールのまま
     （スマホは新スケール）」＝既知の持病「CDN が旧配信物を凍結して返し続ける」の再発。根治策は世代替えのみ
     （過去 asf-theme.css→-2→-3 で2回実証）。よって asf-shop-bg-1.js → asf-shop-bg-2.js（＝このファイル）へ
     世代替え。世代替え時点で asf-shop-bg-1.js の完全なコピー（内容変更なし）。旧 asf-shop-bg-1.js は
     参照ゼロで残置（--nodelete 運用）。★編集先は必ずこの asf-shop-bg-2.js のみ★ 旧名を編集しても
     何も起きず「新たな CDN 凍結」に見える事故になる。次に凍結したら -3 へ。
   ──────────────────────────────────────────────────────────────────────────
   出典: demo-v3/lab/shop-v2.html の ASF_BG IIFE（L1377–1900）を逐語移植。
         固定スナップショット demo-v3/lab/_port-src-b2/shop-v2.html
         （md5 f0d537fe44f450fa5e6848df16262e77・2026-07-31 09:27 の確定版）が基準。
         ラボ原本は別班がスクロール質感を継続改修中だが、ASF_BG（柄の描画）は
         スクロール挙動と独立しているため再同期の予定は無い。
   設計根拠: docs/SHOPV2-PORT-PLAN.md §1-a（新規ファイル）/ §1-d（新規 JS の作法）/
             §I1（音声層に触れない）/ §I4（WebGL JS を liquid にインライン化しない）/
             §R1（SHOP 以外のビューへ漏らさない）/ §R5（最初から世代付きファイル名）。

   ★ なぜ assets/ の別ファイルなのか ★（§1-a / §I4）
     Shopify の「1ファイル 256KB」上限は .liquid（layout/sections/snippets/templates）に効く。
     assets/ の JS/CSS はこの制限外。かつ asf-index.js（154KB・全ビュー共通）へ足すと
     CLUB/LABEL/VISUAL/CHART の初期コストが上がるため、SHOP 専用のこの 2 本を別出しする。

   ★ 不変条件 I1（音声層に触れない）★
     本ファイルは **音声に関わる API・グローバル・DOM を 1 つも参照しない**。
     禁止トークンの一覧は docs/SHOPV2-PORT-PLAN.md §I1 が唯一の記述元（ここに再掲すると
     「一覧を grep して 0 件」という検証手続き自体が自分のコメントに引っかかって成立しなくなる）。
     レビュー時はその一覧で本ファイルを grep して 0 件であることを確認する。
     移植元のラボも品質契約として音声要素ゼロ。旧 #shopBgVideo（<video>）を消して
     <canvas> に置き換える方向なので、音声を増やす変更は構造的に発生しない。

   ★ 世代 ★ -1 は世代番号（§I5・§R5）。CDN 凍結時は -2 を作って差し替える。
   ══════════════════════════════════════════════════════════════════════════ */
window.asfBoot(function(){
'use strict';
if (window.__asfBootShopBgV2) return;                  /* シングルトン・ガード（§1-d 作法） */
window.__asfBootShopBgV2 = true;

/* ── DOM（snippets/asf-shop-bg.liquid が出力）─────────────────────────────
   URL は直書きせず data-* 属性（asset_url 由来）から受け取る（§1-d 必須作法）。 */
var cv = document.getElementById('gl');
if (!cv) return;                                        /* SHOP ビューが無いテンプレートでは無害に不発 */

var SDF_URL = cv.getAttribute('data-sdf') || '';
if (!SDF_URL){ document.body.classList.add('no-webgl'); return; }   /* asset 未解決＝フォールバック PNG へ */

/* --- パラメータ（固定・調整パネルなし） --- */
var P = {
  buzz  : 9.5,   // ジッター振幅(px)。実効は平均 ~3px の微細な粟立ち・スパイク時のみ ~10px 跳ねる
  bfreq : 48,    // 時間の離散化(Hz)。滑らかに補間せず段差で刻む＝ビリビリ
  grain : 18,    // ジッターの粒(px)
  radius: 108,   // 影響半径(px)。実効到達は縁ノイズ込みで ~150px
  scale : 860,   // 柄スケール(px)。2026-07-31 client 指示で PC/SP 統一値へ改訂（下記 SP_SCALE 直上コメント参照）
  thick : .30,   // 通電時の柄の太り／明滅の強さ
  /* --- 常時アンビエント（ラボ指示11「邪魔にならない程度に生きて躍動」）---
     amb      … 揺らぎの振幅(px)。2 オクターブ合成なので理論最大は amb*1.42。
     ambScale … 揺らぎの空間スケール(px)。ブロック（等価直径 64px）より十分大きい 520px に
                することで「柄が砕ける」のではなく「面ごとにゆっくり波打つ」動きになる。
     ambSpd   … ノイズ場の流速(cell/s)。周期の異なる 2 オクターブが重なるので、見かけの
                反復周期を目が掴めない＝端で目が留まらない。
     ★ 採用値はラボで 4 案を実測して決めた（黒枠内 792x630px における輪郭の平均変位）:
         amb 3.0 / spd .13 → 1s:0.35px … 動いていると気づけない
         amb 5.5 / spd .21 → 1s:0.88px … ★採用
         amb 6.0 / spd .24 → 1s:1.05px … 上とほぼ同等
         amb 8.0 / spd .30 → 1s:2.08px … ブロックの形が崩れて主張が出る
       採用値でも 1 秒あたりの輪郭移動は 0.9px ＝ ブロック径 64px の 1.4%。T シャツの浮遊
       （2.25s で 9px 移動＝4px/s）より 1 桁遅く、視線を引く速度域には入らない。 */
  amb     : 5.5,
  ambScale: 520,
  ambSpd  : .21
};

/* --- SP の柄スケール（旧経緯: ラボ追加指示「スマホ版は柄をもっと引きで」→ フォローアップ
   「もう少しだけズーム」で SP のみ 1200→520 に縮小・PC は 1200 のまま不変としていた）---
   ラボでの実測（headless Chromium 390x844 dpr=2・緑塊の連結成分の面積中央値の平方根）:
     scale=400  sqrt(中央値面積)=20.9px  ブロブ数317
     scale=480  =25.3px (400比+21%)      ブロブ数232
     scale=520  =26.9px (400比+29%)      ブロブ数210   ★旧 SP 採用値（480 と 560 のほぼ中間）
     scale=560  =29.0px (400比+38%)      ブロブ数181
     scale=1200 =58.4px (400比+179%)     ブロブ数38    （旧 PC 値）

   ★ 2026-07-31 client 指示「PC版も柄をもう少し引いて、スマホ版の大きさと今の大きさの間くらい
     の柄のサイズに調整して、両方を同じ見え方に揃えてください」で PC/SP 統一へ改訂 ★
   旧 PC=1200 と旧 SP=520 の知覚的な中間として 3 候補（760/860/960）をラボ shop-v2.html で
   PC(1280x800)・SP(390x844 dpr=2) 双方の実スクリーンショット + 緑塊の連結成分解析
   （median blob sqrt-area、フルページ解析）で比較した:
     scale=760   PC sqrt=20.00px (1200比 0.660／期待比 0.633)
     scale=860   PC sqrt=21.95px (1200比 0.724／期待比 0.717) ★採用（線形期待値との誤差が最小）
     scale=960   PC sqrt=25.42px (1200比 0.838／期待比 0.800)
   いずれも「旧PC(1200)より明確に引き／旧SP(520)より明確に大きい」を満たしたため、線形の
   知覚中間（(1200+520)/2=860）にも一致し実測誤差が最小の 860 を採用（迷った場合の既定も 860）。
   P.scale と SP_SCALE を同一値にすることで PC/SP が完全に同じ柄サイズになる。SP 専用の分岐
   （SP_BG_MQ・bgIsSP()・SP_SCALE 変数）はあえて残し、将来 PC/SP を再び分けたくなった場合に
   SP_SCALE の値を変えるだけで済む構造を維持している。

   ★ 揺れ/アンビエントの物理量（相対量不変の担保）★
   ビリビリ/アンビエントの px 量（uBuzz/uGrain/uRadius/uAmb/uAmbScale）は、旧実装では
   「SP のみ k=SP_SCALE/P.scale で縮小・PC は k=1 で無改修」だった。これは P.scale が常に
   1200 で固定という前提に依存しており、P.scale 自体を 860 に変える今回の改修ではこの前提が
   崩れる（PC の k を 1 のまま放置すると、ブロックは小さくなったのに揺れ幅は据え置きになり
   「ブロックに対する相対的な揺れ幅」が旧比 1200/860≒1.395 倍に増幅されてしまう）。
   そこで下の upload() では k の基準を「その時点で有効なスケール(scaleEff)」ではなく
   「揺れ/アンビエントの px 値が実測・調整された元の基準スケール BASE_SCALE=1200」からの比率
   （scaleEff/BASE_SCALE）に改め、PC・SP 両方に同じ考え方で適用する。P.scale=SP_SCALE=860 の
   現状では PC/SP とも k=860/1200=0.71667 で完全に同一となり、揺れの体感は「旧 PC の 1200 基準
   に対して 860/1200 倍だけブロックが縮んだ分、揺れの px 量も同じ比率で縮む」＝ブロックに対する
   相対的な揺れ幅は旧 PC と厳密に不変。
   uAmbSpd はセル/秒の相対値・uBFreq/uThick はスケール無関係のため無改修。
   no-WebGL フォールバックの background-size も同じ 860px に統一済み
   （assets/asf-theme-4.css の #fallback を参照）。 */
var SP_BG_MQ = window.matchMedia ? window.matchMedia('(max-width:820px)') : null;
var SP_SCALE = 860;   // 2026-07-31 client 指示で PC(P.scale)と統一（採用根拠は上記コメント）
var BASE_SCALE = 1200; // 揺れ/アンビエントの px 値(P.buzz/grain/radius/amb/ambScale)が実測・調整
                        // された元の基準スケール。P.scale や SP_SCALE を変えても、この基準からの
                        // 比率で追随させる限りブロックに対する相対的な揺れ幅は変わらない（不変条件）。
function bgIsSP(){ return !!(SP_BG_MQ && SP_BG_MQ.matches); }

var LINGER   = 55,   // 最後の移動から「まだ触れている」とみなす時間(ms)
    TAU_ON   = .028, // 立ち上がり時定数(s)
    TAU_OFF  = .055, // 減衰時定数(s) → 1 → 0.02 まで約 215ms
    TAU_BURST= .060, // タップ/急移動のスパーク減衰(s) → 1 → 0.02 まで約 235ms
    CUT      = .02;  // これ未満は 0 とみなす（＝完全静止の判定閾値）

var MAX_PTR = 6, SDF_SPREAD = 8, SRC_SIZE = 2000;

var gl = null, prog, U = {}, tex, ready = false, inited = false, P3_OK = false;

/* ★ R1（柄が SHOP 以外のビューに漏れる）の緩和 — 2 段構え ★
   ① 描画そのもの: #gl / #fallback は snippets/asf-shop-bg.liquid が <div class="view" id="shop">
      の内側に出力する。他ビュー表示中の #shop は .view{display:none} なので、canvas は
      **そもそもレンダリングされない**（構造的な保証・CSS 1 行にも依存しない）。
   ② rAF: それでもループは回り続けてしまうので、snippets/asf-overlay-host.liquid の
      activate(view) が view==='shop' で start() / それ以外で stop() を呼ぶ（§1-d-2）。
   running はその ON/OFF。wake() と全ポインタハンドラがこのフラグで完全に眠る。 */
var running = false;

/* --- WebGL 初期化は「初めて start() された時」まで遅らせる（本移植での適応・報告事項）---
   ラボは SHOP 専用の単独ページなので即時初期化でよかったが、theme-v3 の index は 5 ビューの
   単一シェル。CLUB 着地時にまで 248KB の SDF を取りにいくのは無駄なので、SHOP が実際に
   アクティブになるまで initGL()（＝テクスチャの fetch を含む）を走らせない。
   SHOP へ直着地（/#shop）した場合は下の「初期状態の同期」でその場で start() される。 */
function ensureGL(){
  if (inited) return;
  inited = true;
  gl = cv.getContext('webgl2', {alpha:false, antialias:false, powerPreference:'high-performance'})
    || cv.getContext('webgl',  {alpha:false, antialias:false, powerPreference:'high-performance'});
  if (!gl){ document.body.classList.add('no-webgl'); return; }
  /* ラボ指示21 の広色域対応。WebGL の drawingBufferColorSpace（Chrome ~100+ / Safari 16.4+）を
     'display-p3' に切り替えられる環境では sRGB の外まで踏み込んだ鮮やかな緑を書き出せる
     （iPhone は 7 以降すべて P3 ディスプレイ）。未対応環境は sRGB 経路へフォールバック
     （2026-07-31 fix4 で #85FF34 → #3EFE00。算出根拠は下の initGL() 内コメントが唯一の記述元）。

     ★ 2026-07-31 director 裁定による修正（B4）★
       当初はブラウザが drawingBufferColorSpace を受け付けるかどうか **だけ** で分岐していたが、
       それだと「API は対応しているがディスプレイは sRGB」という環境（デスクトップ Chrome の
       非広色域モニタ・headless Chromium など）でも P3 経路に入る。P3 の uniform
       color(display-p3 0.42 1 0.04) は線形 sRGB へ変換すると R/B が負値になる＝sRGB では
       physically 再現不能なので、sRGB へクランプされて **#00FF00 付近の純緑** に沈む。
       実測（headless Chromium 1440x900・スクリーンショットのピクセル値）:
         WebGL 版（P3 経路） #00FF00 ／ no-WebGL フォールバック PNG #85FF34
       ＝ 同じ柄なのに WebGL の有無で色が割れていた（B2 完了報告で懸念として提出した件）。
       対処: ディスプレイが実際に P3 を表示できるときだけ P3 経路に入る。
       (color-gamut: p3) はメディアクエリ仕様の「出力デバイスが概ね P3 色域を再現できる」判定で、
       これを AND 条件に足すことで sRGB 環境では必ず sRGB 経路の色が厳密に出るようになる。
       ラボ側（demo-v3/lab）にも別班が同一の修正を適用中。
       ★ 2026-07-31 fix4 追記 ★ このゲート自体は正しく働いていた（クライアントの Mac 実機で
         matchMedia('(color-gamut: p3)') === false を採取済み）。「Mac だと緑が薄い」の原因は
         ゲートではなく **sRGB 経路の色そのもの** だったので、ゲートは無改修・色だけ差し替えた。 */
  P3_OK = false;
  var p3Display = !!(window.matchMedia && window.matchMedia('(color-gamut: p3)').matches);
  if (p3Display && 'drawingBufferColorSpace' in gl){
    try{
      gl.drawingBufferColorSpace = 'display-p3';
      P3_OK = (gl.drawingBufferColorSpace === 'display-p3');
    } catch(e){ P3_OK = false; }
  }
  try { initGL(); } catch (err){ document.body.classList.add('no-webgl'); }
}

var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';

var FS = [
'precision highp float;',
'#define MAX_PTR ' + MAX_PTR,
'uniform vec2 uRes; uniform float uTime, uScale, uAA;',
'uniform vec4 uPtr[MAX_PTR];',                       // xy=px(top-down) / z=接触強度 / w=スパーク
'uniform sampler2D uSdf; uniform vec3 uPaper, uSignal;',
'uniform float uBuzz, uBFreq, uGrain, uRadius, uThick;',
'uniform float uAmb, uAmbScale, uAmbSpd;',            // 常時アンビエント

'float h11(float n){ return fract(sin(n * 127.1) * 43758.5453123); }',
'vec2 h22(vec2 p){',
'  p = vec2(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)));',
'  return fract(sin(p) * 43758.5453123);',
'}',
/* 空間方向は滑らかに補間する（柄が砕けず「震える」）。時間方向は floor で段差にする（＝電気）。*/
'float n1(vec2 p, float sd){',
'  vec2 i = floor(p), f = fract(p); f = f * f * (3.0 - 2.0 * f);',
'  float a = h22(i + sd).x, b = h22(i + vec2(1.0,0.0) + sd).x;',
'  float c = h22(i + vec2(0.0,1.0) + sd).x, d = h22(i + vec2(1.0,1.0) + sd).x;',
'  return mix(mix(a,b,f.x), mix(c,d,f.x), f.y);',
'}',
'vec2 n2(vec2 p, float sd){',
'  vec2 i = floor(p), f = fract(p); f = f * f * (3.0 - 2.0 * f);',
'  vec2 a = h22(i + sd), b = h22(i + vec2(1.0,0.0) + sd);',
'  vec2 c = h22(i + vec2(0.0,1.0) + sd), d = h22(i + vec2(1.0,1.0) + sd);',
'  return mix(mix(a,b,f.x), mix(c,d,f.x), f.y) * 2.0 - 1.0;',
'}',

'void main(){',
'  vec2 Pp = vec2(gl_FragCoord.x, uRes.y - gl_FragCoord.y);',   // top-down: DOM 座標と一致
'  float ti = floor(uTime * uBFreq);',                          // 離散化した時刻

   /* --- ポインター近傍のエネルギー（伝播なし・距離で即座に落ちる） --- */
'  float energy = 0.0;',
'  for (int i = 0; i < MAX_PTR; i++){',
'    vec4 pt = uPtr[i];',
'    if (pt.z + pt.w <= 0.0) continue;',            // 一瞬のタップは z≒0 / w のみ＝ここで落とさない
'    float r = distance(Pp, pt.xy) / uRadius;',
'    if (r > 1.6) continue;',
'    float edge = 0.74 + 0.52 * n1(Pp / (uRadius * 0.40), ti * 3.71);',  // 縁がギザつく＝放電感
'    float k = exp(-r * r * 2.1) * smoothstep(1.42 * edge, 0.50 * edge, r);',
'    energy += (pt.z + pt.w * 0.85) * k;',
'  }',
'  float e = min(energy, 1.6);',

   /* --- 静電ジッター: 微細な粒 + 全体の小突き。スパイクゲートで「たまに鋭く」 --- */
'  vec2 disp = vec2(0.0);',
'  if (e > 0.006){',
'    float spike = pow(h11(ti + 3.17), 4.0);',                  // ほとんど小・稀に大
'    float amp   = uBuzz * e * (0.22 + 1.45 * spike);',
'    vec2  fine  = n2(Pp / uGrain, ti * 17.13);',                // 粒状の粟立ち
'    vec2  kick  = h22(vec2(ti, 7.73)) * 2.0 - 1.0;',            // 領域まるごとの一撃＝ピクッと来る
'    disp = (fine * 0.60 + kick * 0.85) * amp;',
'  }',

   /* --- アンビエント（ラボ指示11「邪魔にならない程度に生きて躍動」）------------------
      ビリビリ（上）は **触れた場所だけ・段差の時間** で「電気」を作る。こちらは真逆の設計で、
      **画面全体・連続した時間** のごく遅いドメインワープ＝「呼吸/漂い」を作り、単純加算で共存させる。
        ・2 オクターブの value noise を空間 uAmbScale(px) / 時間 uAmbSpd(cell/s) で流す。
        ・場所ごとに向きが違う（rigid な平行移動ではない）＝布がゆっくり波打つ見え。
        ・振幅は uAmb(px)。柄のブロックは等価直径 64px なので数 px は「輪郭がわずかに呼吸する」量。 */
'  vec2 q = Pp / uAmbScale;',
'  vec2 amb = vec2(n1(q + vec2( uTime * uAmbSpd,        uTime * uAmbSpd * 0.64), 2.13),',
'                  n1(q + vec2(-uTime * uAmbSpd * 0.79, uTime * uAmbSpd * 1.12), 8.71)) * 2.0 - 1.0;',
'  amb += 0.42 * (vec2(n1(q * 2.3 + vec2( uTime * uAmbSpd * 1.9, -uTime * uAmbSpd * 1.5), 4.70),',
'                      n1(q * 2.3 + vec2(-uTime * uAmbSpd * 1.7,  uTime * uAmbSpd * 2.1), 6.10)) * 2.0 - 1.0);',
'  disp += amb * uAmb;',

   /* --- SDF をサンプル。稀に線幅が跳ねる＝鋭い明滅 --- */
'  float s = texture2D(uSdf, (Pp + disp) / uScale).r - 0.5;',
'  float flick = step(0.94, h11(ti + 11.37)) * (h11(ti * 1.7 + 5.1) - 0.30);',   // 約 3 回/秒
'  s += uThick * e * (0.09 + 0.55 * flick);',
'  gl_FragColor = vec4(mix(uPaper, uSignal, smoothstep(-uAA, uAA, s)), 1.0);',
'}'
].join('\n');

function compile(type, src){
  var sh = gl.createShader(type);
  gl.shaderSource(sh, src); gl.compileShader(sh);
  if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(sh));
  return sh;
}

function initGL(){
  prog = gl.createProgram();
  gl.attachShader(prog, compile(gl.VERTEX_SHADER, VS));
  gl.attachShader(prog, compile(gl.FRAGMENT_SHADER, FS));
  gl.bindAttribLocation(prog, 0, 'a');
  gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog));
  gl.useProgram(prog);
  ['uRes','uTime','uScale','uAA','uPtr','uSdf','uPaper','uSignal',
   'uBuzz','uBFreq','uGrain','uRadius','uThick','uAmb','uAmbScale','uAmbSpd']
    .forEach(function(n){ U[n] = gl.getUniformLocation(prog, n); });

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
  gl.enableVertexAttribArray(0);
  gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);

  tex = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, 1, 1, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8Array([0]));
  gl.uniform1i(U.uSdf, 0);
  /* 色（SDF・シェーダ本体・描画は一切不変）:
       uPaper  = 地（割れ目）#F5F5F5
       uSignal = 図（ブロック）。P3 経路 / sRGB 経路で **同じ色の 2 つの表現** を使い分ける。

     ★★ 2026-07-31 fix4 タスク1 — sRGB 経路を #85FF34 → #3EFE00 へ ★★
       クライアント実機報告（原文引用）「Mac で見ると柄の緑が薄い」。
       採取済みの実地データ: クライアントの Mac は matchMedia('(color-gamut: p3)') が false
       ＝下の P3 ゲートに落ちて **sRGB 経路** で描かれていた。iPhone（P3 経路）の鮮烈さと
       見比べて薄い、というのがこの報告の実体。P3 経路は正しく効いているので触らない。

       採用色の求め方（推測ではなく計算）: P3 側の実値 color(display-p3 0.42 1 0.04) を
       OKLab/OKLCH（知覚均等色空間）へ変換すると
           OKLCH(L=86.85%, C=0.3342, h=141.02°)
       で、C=0.3342 は sRGB 色域の外（線形 sRGB に直すと R=-0.045 / B=-0.078 と負値）。
       そこで **L と h を保ったまま C だけを sRGB 色域の境界まで落とす**（＝CSS Color 4 の
       ガマットマッピングと同じ方針で、彩度を最優先し、明度と色相はズラさない）:
           OKLCH(86.85%, 0.2857, 141.02°) → sRGB #3EFE00 rgb(62,254,0)
       P3 目標との知覚差 ΔEOK は 0.0905（旧 #85FF34）→ **0.0478**（新 #3EFE00）で約半減。
       ・旧 #85FF34 は L=89.4% / C=0.2506 / h=136.4° — 明るすぎ・彩度不足・黄寄りの 3 重ズレで、
         紙白 #F5F5F5 の上に置くと「薄い」に見える。
       ・純緑 #00FF00（＝素朴にクリップした場合の値）は ΔEOK 0.0402 と数値上は最も近いが、
         h=142.5° の "安い純緑" になるため不採用（director 指示）。#3EFE00 は R=62 を残すので
         同じ蛍光イエローグリーン系のまま「パキッと濃い」側へ寄る。
       実スクショ比較（demo-v3/lab/_shots/fix4-*.png）で ±候補
         #4DFF00(ΔEOK .0514) / #5AFF14(.0585) / #66FF00(.0620) / 旧 #85FF34(.0905)
       と並べ、彩度優先の指示どおり最も濃い #3EFE00 を採用した。
       ★ 変更時は 3 箇所を必ず揃える ★ ここ / assets/asf-theme-4.css の --shop-signal /
         フォールバック PNG（assets/asf-pattern-fallback-2.png）。 */
  gl.uniform3f(U.uPaper,  0xF5/255, 0xF5/255, 0xF5/255);
  if (P3_OK){
    /* Display P3 の生値をそのまま uniform へ渡す（drawingBufferColorSpace が display-p3 の間、
       gl_FragColor の数値は P3 のガンマ値として解釈される）。color(display-p3 0.42 1.0 0.04) 相当。
       線形 sRGB へ変換すると R/B が負値になる＝sRGB では物理的に再現不可能な緑。
       P3 ディスプレイ（iPhone 7 以降ほぼ全機種）でだけこの鮮やかさが乗る。
       ★ fix4 でも **現状維持**（クライアントの iPhone 実機評価は「鮮烈で良い」＝変更対象外） */
    gl.uniform3f(U.uSignal, 0.42, 1.0, 0.04);
  } else {
    /* sRGB 経路（クライアントの Mac / 非広色域ディスプレイ / headless）。上の算出根拠を参照。 */
    gl.uniform3f(U.uSignal, 0x3E/255, 0xFE/255, 0x00/255);
  }

  var img = new Image();
  img.onload = function(){
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, gl.LUMINANCE, gl.UNSIGNED_BYTE, img);
    /* ★ ラップは MIRRORED_REPEAT ではなく REPEAT ★
       クライアント指摘「PC 版の背景の繋ぎ目が気になる。繋ぎ目から左右対称に広がり、中央にあるので
       目立つ」の根治。旧 SDF はタイル境界で柄が連続しない（左端列と右端列の平均差 113/255）ため
       素の REPEAT では継ぎ目が線として出る。それを隠すための鏡像反復は「継ぎ目を軸とする左右対称」
       を作り、人間の視覚は対称軸を極めて鋭敏に検出するので問題が悪化していた。
       対処は「隠す」ではなく素材の作り直し: トーラス上でシームレス化した
       assets/asf-pattern-sdf-1.png（ラボ pattern-sdf-seamless-1024.png）に差し替え REPEAT へ戻した。
       ※ REPEAT + mipmap は WebGL1 では POT テクスチャ必須。1024x1024 なので条件を満たす。 */
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.generateMipmap(gl.TEXTURE_2D);
    ready = true;
    resize(); draw();
    wake();
  };
  img.onerror = function(){ document.body.classList.add('no-webgl'); };
  /* ── シームレス SDF（assets/asf-pattern-sdf-1.png）──────────────────────────
     素材はクライアント承認済みの柄。生成法はトーラス上の graphcut quilting:
       ① 元 SDF を「符号付き距離（texel 単位）」に復号し exemplar とする。
       ② 192px パッチ・ステップ 128 の 8x8 ラスタ走査で 1024x1024 を合成。貼り付け座標は
          mod 1024 で巻き付くので、最後の行/列のパッチはタイル境界そのものを跨いで合成される
          ＝ 周期性が構成的に保証される（後付けの補修ではない）。
       ③ パッチの継ぎ目は Kwatra 流 graphcut（min-error boundary cut）で決める。距離場空間で
          切るので輪郭が滑らかに繋がり、直線状の継ぎ目もブレンドのボケも残らない。
       ④ 最後に 3x3 タイル → EDT → 中央切り出しの「周期 EDT」で距離を引き直す。
     柄のスケール感は不変 — 図の面積率 .6186→.6185、ブロックの中央値面積 3185px²→3214px²
     （等価直径 63.7px→64.0px @2000）で実測一致。
     フォールバック PNG（2026-07-31 fix4 以降は assets/asf-pattern-fallback-2.png）も同じ距離場から
     再描画済み ＝ WebGL 版と no-WebGL 版で完全に同一の柄・同一のシームレス性
     （fix4 の再着色は混合率を保存する inverse-mix なので、この同一性は色替え後も維持されている）。
     ★ URL は直書きせず data-sdf（asset_url 由来）から受け取る（§1-d 必須作法）★ */
  img.src = SDF_URL;
}

/* ══════════════════════════════════════════════════════════════════════════
   resize() — canvas を「常にビューポート全高」に保つ
   ★★ 2026-07-31 fix4 タスク3 ★★
   ──────────────────────────────────────────────────────────────────────────
   クライアント実機報告（原文引用）「最初に表示されている画面で、下に friends tee は綺麗に
   画面下部まで表示されて見切れているが、背景の柄は画面最下部まで表示されておらず、途中で
   見切れてしまっている。ダサいのですぐに修正」

   ★ 原因 ★ 旧実装は CSS サイズを **window.innerHeight で上書き** していた。
     iOS Safari の window.innerHeight は「URL バーが出ている状態の可視高さ（＝小ビューポート
     100svh 相当）」を返す。一方 #gl の CSS は position:fixed; inset:0（assets/asf-theme-4.css）
     ＝ 大ビューポート（100lvh 相当）の高さを持つ。つまり **初期表示（URL バー展開時）に
     JS が canvas を lvh−svh ぶんだけ短く潰していた**。その差分が「柄が最下部まで届かず
     途中で切れる」の正体（T シャツ側は通常フローなので影響を受けず、報告どおり下端まで出る）。
     さらに URL バーが縮んで innerHeight が増えても、増えたぶんを埋めるのは resize 経由なので
     一瞬とはいえ必ず欠けが出る。

   ★ 対処 ★ CSS サイズは **JS が一切書かない**（inline style を明示的に空へ戻して CSS へ委譲）。
     描画バッファのサイズだけを「実際の canvas の CSS ボックス（clientWidth/clientHeight）と
     innerHeight / visualViewport.height のうち最大値」から決める。max を取るのは、
     URL バーの伸縮のどの位相でも **短くなる方向へは絶対に振れない** ようにするため
     （長すぎるぶんは画面外へはみ出すだけで、欠けは絶対に起きない）。

   ★ タスク2 の resize ガードとの関係（重要）★
     assets/asf-shop-grid-2.js には「幅が変わっていない resize は無視する」ガードがあるが、
     あれは **スクロール位置の再スナップ処理だけ** に掛かるガードで、本ファイルとは無関係。
     canvas のリサイズは高さ変化でも必ず追随させる（下の resize リスナ + visualViewport 監視）。
   ══════════════════════════════════════════════════════════════════════════ */
var dpr = 1, W = 0, H = 0;
function viewportH(){
  var h = window.innerHeight || 0;
  if (window.visualViewport && window.visualViewport.height) h = Math.max(h, window.visualViewport.height);
  if (cv.clientHeight) h = Math.max(h, cv.clientHeight);          /* CSS(position:fixed;inset:0)の実高 */
  if (document.documentElement) h = Math.max(h, document.documentElement.clientHeight);
  return h;
}
function viewportW(){
  var w = window.innerWidth || 0;
  if (cv.clientWidth) w = Math.max(w, cv.clientWidth);
  return w;
}
function resize(){
  dpr = Math.min(window.devicePixelRatio || 1, 2);
  /* 過去に書き込まれた inline サイズを消して CSS（#gl{position:fixed;inset:0}）へ完全委譲する。
     ※ 消してから測ることで、旧世代のキャッシュ済み JS が残した値の影響も受けない。 */
  if (cv.style.width || cv.style.height){ cv.style.width = ''; cv.style.height = ''; }
  W = Math.round(viewportW() * dpr);
  H = Math.round(viewportH() * dpr);
  if (cv.width !== W || cv.height !== H){ cv.width = W; cv.height = H; }
  gl.viewport(0, 0, W, H);
}

/* --- 入力状態 --- */
var pointers = {};            // id -> {x,y,i,burst,down,last,stale}
var simTime = 0, lastTS = 0, raf = null;
var ptrBuf = new Float32Array(MAX_PTR * 4);
var PRM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
function reduced(){ return !!(PRM && PRM.matches); }

function upload(){
  ptrBuf.fill(0);
  var m = 0;
  for (var id in pointers){
    var pt = pointers[id];
    if (m >= MAX_PTR) break;
    if (pt.i <= CUT && pt.burst <= CUT) continue;
    ptrBuf[m*4]   = pt.x * dpr;
    ptrBuf[m*4+1] = pt.y * dpr;
    ptrBuf[m*4+2] = pt.i;
    ptrBuf[m*4+3] = pt.burst;
    m++;
  }
  /* scaleEff = 今この瞬間に有効な柄スケール（PC は P.scale、SP は SP_SCALE。2026-07-31 改訂で
     両者は同値=860 だが、将来また分けられるようこの分岐構造は残す）。
     k はビリビリ/アンビエントの px 量（uBuzz/uGrain/uRadius/uAmb/uAmbScale）をブロックサイズに
     連動させるための係数で、それらの px 値が実測・調整された元の基準 BASE_SCALE（1200）から
     scaleEff がどれだけ縮小/拡大したかの比率。PC・SP どちらも同じ式を通るため、ブロックに対する
     相対的な揺れ幅は常に「BASE_SCALE=1200 のときの見え方」で揃う。 */
  var scaleEff = bgIsSP() ? SP_SCALE : P.scale;
  var k = scaleEff / BASE_SCALE;
  gl.uniform4fv(U.uPtr, ptrBuf);
  gl.uniform2f(U.uRes, W, H);
  gl.uniform1f(U.uTime,   simTime);
  gl.uniform1f(U.uScale,  scaleEff * dpr);
  gl.uniform1f(U.uAA,     Math.max((SRC_SIZE / (2 * SDF_SPREAD)) * 0.5 / (scaleEff * dpr), 0.012));
  gl.uniform1f(U.uBuzz,   P.buzz   * k * dpr);
  gl.uniform1f(U.uBFreq,  P.bfreq);
  gl.uniform1f(U.uGrain,  P.grain  * k * dpr);
  gl.uniform1f(U.uRadius, P.radius * k * dpr);
  gl.uniform1f(U.uThick,  P.thick);
  gl.uniform1f(U.uAmb,      P.amb * k * dpr);
  gl.uniform1f(U.uAmbScale, P.ambScale * k * dpr);
  gl.uniform1f(U.uAmbSpd,   P.ambSpd);
  return m;
}
function draw(){
  if (!ready) return 0;
  var n = upload();
  gl.drawArrays(gl.TRIANGLES, 0, 3);
  return n;
}

/* --- アニメーションループ（ラボ指示11: アイドル完全停止 → 常時アンビエント）-----------
   ループは **常時回す** 設計。負荷はここで 4 段に抑える:
     ① アイドル中の描画は AMB_FPS(30Hz) に間引く（アンビエントは 7.7s 周期なので 30Hz と
        60Hz の差は原理的に見えない。GPU 時間はそのまま半減）。触っている間（ビリビリ）は
        間引かずフル rAF ＝ 手触りは一切変わらない。
     ② タブ非表示は rAF ごと停止（visibilitychange。復帰時に wake() で再開）。
     ③ prefers-reduced-motion では 1 枚の静止画で完全停止。
     ④ ★本移植で追加★ SHOP ビューが非アクティブの間は running=false で rAF ごと停止（§R1）。 */
var AMB_FPS = 30, AMB_DT = 1 / AMB_FPS, ambAcc = 0;

function busy(){
  for (var id in pointers){
    var pt = pointers[id];
    if (pt.i > CUT || pt.burst > CUT) return true;
  }
  return false;
}
function tick(ts){
  var dt = lastTS ? Math.min((ts - lastTS) / 1000, .05) : .016;
  lastTS = ts; simTime += dt;

  for (var id in pointers){
    var pt = pointers[id];
    var active = pt.down || (ts - pt.last < LINGER);
    var tau = active ? TAU_ON : TAU_OFF;
    pt.i += ((active ? 1 : 0) - pt.i) * (1 - Math.exp(-dt / tau));
    pt.burst *= Math.exp(-dt / TAU_BURST);
    if (!active && pt.i < CUT && !pt.down){
      pt.i = 0;
      if (pt.burst < CUT){ pt.burst = 0; if (pt.stale) delete pointers[id]; }
    }
  }

  var hot = busy();                      // ポインターのエネルギーが残っている＝ビリビリ中
  ambAcc += dt;
  if (hot || ambAcc >= AMB_DT){ ambAcc = 0; draw(); }

  if (reduced() || !running){            // 途中で reduced-motion / 非アクティブへ切り替わった場合の出口
    raf = null; lastTS = 0; ambAcc = 0;
    for (var j in pointers){ pointers[j].i = 0; pointers[j].burst = 0; }
    simTime = 0; draw();
    return;
  }
  raf = requestAnimationFrame(tick);
}
function wake(){
  if (raf || !running || !ready || reduced() || document.hidden) return;
  lastTS = 0; raf = requestAnimationFrame(tick);
}

/* --- ポインター入力（マルチタッチ対応・window で受けるのでカード上でも背景へ通る）---
   ★ running=false（SHOP 非アクティブ）の間は全ハンドラが即 return ＝ 他ビューでは
     イベント処理コストも rAF もゼロ（§R1）。 */
function onDown(e){
  if (!running || reduced()) return;
  var pt = pointers[e.pointerId];
  if (!pt) pt = pointers[e.pointerId] = { x:e.clientX, y:e.clientY, i:0, burst:0, down:true, last:0, stale:false };
  pt.x = e.clientX; pt.y = e.clientY;
  pt.down = true; pt.last = performance.now();
  pt.stale = (e.pointerType !== 'mouse');
  pt.burst = 1.0;                        // 触れた瞬間だけ弾ける（伝播はしない）
  pt.i = Math.max(pt.i, .5);             // 一瞬のタップでも芯が出るよう即座に立ち上げる
  wake();
}
function onMove(e){
  if (!running || reduced()) return;
  var now = performance.now();
  var pt = pointers[e.pointerId];
  if (!pt){
    pt = pointers[e.pointerId] = { x:e.clientX, y:e.clientY, i:0, burst:0, down:false, last:now,
                                   stale:(e.pointerType !== 'mouse') };
  }
  var dx = e.clientX - pt.x, dy = e.clientY - pt.y;
  var v  = Math.sqrt(dx*dx + dy*dy) / Math.max(now - pt.last || 16, 1) * 1000;   // px/s
  pt.x = e.clientX; pt.y = e.clientY; pt.last = now;
  if (v > 1100) pt.burst = Math.max(pt.burst, .45);                              // 速い動きで小さな火花
  wake();
}
function onUp(e){
  if (!running) return;
  var pt = pointers[e.pointerId];
  if (!pt) return;
  pt.down = false;
  pt.last = 0;                           // 猶予なしで即減衰 → 離すと ~0.28s で静止
  if (e.pointerType !== 'mouse') pt.stale = true;
  wake();
}

window.addEventListener('pointerdown',   onDown, {passive:true});
window.addEventListener('pointermove',   onMove, {passive:true});
window.addEventListener('pointerup',     onUp,   {passive:true});
window.addEventListener('pointercancel', onUp,   {passive:true});
window.addEventListener('pointerleave',  onUp,   {passive:true});

/* タブ非表示では rAF ごと停止。復帰で常時アンビエントを再開する。 */
document.addEventListener('visibilitychange', function(){
  if (document.hidden){
    if (raf){ cancelAnimationFrame(raf); raf = null; }
    lastTS = 0; ambAcc = 0;
    for (var id in pointers){ pointers[id].i = 0; pointers[id].burst = 0; }
  } else if (ready && running){ draw(); wake(); }
});
/* reduced-motion の切り替えに追従。ON で静止 1 枚・OFF で再開 */
if (PRM){
  var onPRM = function(){
    if (reduced()){
      if (raf){ cancelAnimationFrame(raf); raf = null; }
      lastTS = 0; ambAcc = 0; simTime = 0;
      for (var id in pointers){ pointers[id].i = 0; pointers[id].burst = 0; }
      if (ready) draw();
    } else wake();
  };
  if (PRM.addEventListener) PRM.addEventListener('change', onPRM);
  else if (PRM.addListener) PRM.addListener(onPRM);
}
/* ★ 2026-07-31 fix4 タスク3 ★ 高さだけの変化（iOS の URL バー伸縮）でも必ず追随する。
   ここに「幅が変わったときだけ」のガードを入れてはいけない（それを入れたのが
   assets/asf-shop-grid-2.js 側で、あちらは **スクロール位置の再スナップ** に限った話。
   canvas のサイズ追随に同じガードを掛けると柄の下端が欠けたまま固定される＝本タスクの不具合）。 */
window.addEventListener('resize', function(){ if (!ready || !running) return; resize(); draw(); });
/* visualViewport は URL バーの伸縮・ソフトキーボード・ピンチで resize より細かく発火する
   （iOS Safari では URL バーの収縮が window resize を伴わない位相がある）。同じ処理を繋ぐ。 */
if (window.visualViewport){
  var onVV = function(){ if (!ready || !running) return; resize(); draw(); };
  window.visualViewport.addEventListener('resize', onVV);
  window.visualViewport.addEventListener('scroll', onVV);
}
/* URL バーの収縮はスクロール中に起きるので、スクロール中にも安全弁として寸法を突き合わせる。
   実際にサイズが変わったときだけ描き直すので、通常のスクロール中は比較 2 回ぶんのコストしか無い。 */
window.addEventListener('scroll', function(){
  if (!ready || !running) return;
  var w = Math.round(viewportW() * dpr), h = Math.round(viewportH() * dpr);
  if (w !== W || h !== H){ resize(); draw(); }
}, { passive:true });

/* ══════════════════════════════════════════════════════════════════════════
   公開 API（snippets/asf-overlay-host.liquid の activate(view) が呼ぶ・§1-d-2 / §R1 / §R11）
     start() … SHOP がアクティブになった。初回だけ WebGL を初期化してから rAF を回す。
     stop()  … SHOP から離れた。rAF を止める（canvas 自体は .view{display:none} で消える）。
   旧実装（#shopBgVideo の再生/一時停止）と 1:1 で置き換わる位置。
   ★ I1 ★ ここに音声への参照は一切無い（video を消して canvas にした＝音源は構造的に無関係）。
   ══════════════════════════════════════════════════════════════════════════ */
function start(){
  if (running) return;
  running = true;
  ensureGL();
  if (ready){ resize(); draw(); }
  wake();
}
function stop(){
  if (!running) return;
  running = false;
  if (raf){ cancelAnimationFrame(raf); raf = null; }
  lastTS = 0; ambAcc = 0;
  for (var id in pointers){ delete pointers[id]; }
}

window.ASF_SHOP_BG = {
  start: start,
  stop: stop,
  get running(){ return running; },
  get ready(){ return ready; },
  params: P
};

/* --- 初期状態の同期 ------------------------------------------------------
   ホストは 2 種類ある:
     ① index シェル … 〈div class="view" id="shop"〉 の内側。ビュー切替に追随する必要があるので
        snippets/asf-overlay-host.liquid の activate() が start()/stop() を呼ぶ。ただし asfBoot の
        キューは登録順に走り、そちらの初期 route() は **この IIFE より前** に走るため、SHOP へ
        直着地した場合の start() を取りこぼす。ここで #shop の状態を読んで自力で追いつく。
     ② 直リンク PDP（/products/〈handle〉・sections/asf-product.liquid）… ビューという概念が無く、
        柄は常に出したままでよい。#shop が DOM に存在しないことでこのホストだと判別できる
        （2026-07-31 B4 で追加。これが無いと直リンク PDP で誰も start() を呼ばず柄が出ない）。 */
var shopView = document.getElementById('shop');
if (!shopView || shopView.classList.contains('is-active')) start();
});
